import { Link as BaseLink } from '@react-pdf/renderer';
import useTheme from '../useTheme';

import React from 'react';

export default function Link({ children, variant, style, ...rest }) {
  const { theme } = useTheme();
  const linkStyle = theme?.components?.Link
    ? {
        ...theme?.components?.Link.base,
        ...theme?.components?.Link[variant],
      }
    : {};
  return (
    <BaseLink style={[linkStyle, style]} {...rest}>
      {children}
    </BaseLink>
  );
}
